<template>
  <svg
    aria-hidden="true"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ...attributes
  >
    <path
      d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
      stroke="#596A73"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
      stroke="#596A73"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path d="M12 1V9" stroke="#596A73" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M12 15L12 23" stroke="#596A73" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M4.11523 4.11426L9.60095 9.59997" stroke="#596A73" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M14.4004 14.4L19.8861 19.8857" stroke="#596A73" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M1 12H9" stroke="#596A73" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M15 12L23 12" stroke="#596A73" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M4.11523 19.8857L9.60095 14.4" stroke="#596A73" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M14.4004 9.59997L19.8861 4.11426" stroke="#596A73" stroke-linecap="round" stroke-linejoin="round"></path>
  </svg>
</template>
